import { Component, type ErrorInfo, type ReactNode } from "react"

interface ErrorBoundaryProps {
  children: ReactNode
}

interface ErrorBoundaryState {
  error: Error | null
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  override state: ErrorBoundaryState = { error: null }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error }
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Error boundary caught:", error, info.componentStack)
  }

  override render() {
    if (this.state.error) {
      return (
        <div className="py-16 text-center">
          <p className="text-5xl font-bold">Something went wrong</p>
          <p className="mt-2 text-sage-400">{this.state.error.message}</p>
          <button
            onClick={() => this.setState({ error: null })}
            className="mt-6 rounded-md bg-cream-100 px-4 py-2 text-sm font-medium text-forest-900 hover:bg-cream-50"
          >
            Try again
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
